// Client-side wrappers for restricted Core integrations.
// These proxy through backend functions (aiInvoke, generateAiImage,
// generateAiVideo, sendAppEmail) that run with asServiceRole and require
// admin auth — protecting integration credits from direct client access.
//
// UploadPublicFile and UploadPrivateFile remain direct client calls (not restricted).
import { base44 } from '@/api/base44Client';

export async function invokeLLM(params) {
  const res = await base44.functions.invoke('aiInvoke', params);
  return res.data;
}

export async function generateImage(params) {
  const res = await base44.functions.invoke('generateAiImage', params);
  return res.data;
}

export async function generateVideo(params) {
  const res = await base44.functions.invoke('generateAiVideo', params);
  return res.data;
}

export async function sendAppEmail(params) {
  const res = await base44.functions.invoke('sendAppEmail', params);
  return res.data;
}